import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const refFromLink = params.get("ref") || "";
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [referralCode, setReferralCode] = useState(refFromLink);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await register(name, email, password, referralCode);
    setLoading(false);
    if (res.success) navigate("/account");
    else setError(res.error);
  };

  return (
    <div className="container-lookers py-20 max-w-md mx-auto" data-testid="register-page">
      <h1 className="font-serif text-4xl mb-8 text-zinc-900">
        Create Account
      </h1>
      {refFromLink && (
        <p className="text-sm text-emerald-600 mb-4" data-testid="referral-applied-note">
          Referral code <strong>{refFromLink}</strong> will be applied — you'll get bonus credit on your first order.
        </p>
      )}
      <form onSubmit={onSubmit} className="space-y-4">
        <input required placeholder="Full name" value={name} onChange={(e) => setName(e.target.value)} className="w-full bg-white border border-zinc-200 px-3 py-3 text-sm text-zinc-900 placeholder:text-zinc-400 rounded-sm focus:border-teal-600 outline-none" data-testid="register-name-input" />
        <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-white border border-zinc-200 px-3 py-3 text-sm text-zinc-900 placeholder:text-zinc-400 rounded-sm focus:border-teal-600 outline-none" data-testid="register-email-input" />
        <input type="password" required minLength={6} placeholder="Password (min 6 characters)" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-white border border-zinc-200 px-3 py-3 text-sm text-zinc-900 placeholder:text-zinc-400 rounded-sm focus:border-teal-600 outline-none" data-testid="register-password-input" />
        <input placeholder="Referral code (optional)" value={referralCode} onChange={(e) => setReferralCode(e.target.value)} className="w-full bg-white border border-zinc-200 px-3 py-3 text-sm text-zinc-900 placeholder:text-zinc-400 rounded-sm focus:border-teal-600 outline-none" data-testid="register-referral-input" />
        {error && <p className="text-sm text-destructive" data-testid="register-error">{error}</p>}
        <button type="submit" disabled={loading} className="w-full bg-teal-600 hover:bg-teal-700 text-ink font-heading font-semibold text-xs uppercase tracking-wide py-3.5 rounded-full transition-colors disabled:opacity-50" data-testid="register-submit-button">
          {loading ? "Creating…" : "Create Account"}
        </button>
      </form>
      <p className="text-sm text-zinc-500 mt-6">
        Already have an account? <Link to="/login" className="underline text-teal-700" data-testid="go-to-login-link">Log in</Link>
      </p>
    </div>
  );
}
